import TextEditor, { projectDefaultToolbar } from './TextEditor';

export { projectDefaultToolbar };
export default TextEditor;
